import { Theme } from '@ublend-npm/aulaui-core';

export const createStyles = (theme: Theme) => {
  const { palette } = theme;
  const isDark = palette.mode == 'dark';

  return {
    container: {
      width: { xs: 343, md: 560 },
      bgcolor: 'background.paper',
      borderRadius: '8px',
      boxSizing: 'border-box',
      p: '16px',
      outline: 'none',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1rem',
      mb: '12px',
    },
    title: {
      fontSize: '20px',
      fontWeight: '500',
      lineHeight: '1.66',
      letterSpacing: '0.15px',
      fontFamily: theme?.typography?.fontFamily,
    },
    closeButton: {
      color: isDark ? '#FFFFFF8F' : '#231F298F',
    },
    content: {
      fontFamily: theme?.typography?.fontFamily,
    },
    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    iconBackground: {
      height: '44px',
      width: '44px',
      borderRadius: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    description: {
      textAlign: 'center',
      py: '16px',
      fontSize: '14px',
      lineHeight: '1.43',
      letterSpacing: '0.17px',
      color: isDark ? '#FFFFFFB2' : '#00000099',
    },
    footer: {
      display: 'flex',
      justifyContent: 'end',
      gap: '10px',
    },
    cancelButton: {
      height: '42px',
      px: '22px',
      py: '8px',
      fontSize: '15px',
      fontWeight: '500',
      flexShrink: 0,
      '&:hover': {
        borderColor: palette.primary.dark,
        backgroundColor: palette.action.hover,
      },
      textTransform: 'none',
    },
    confirmButton: {
      height: '42px',
      px: '22px',
      py: '8px',
      fontSize: '15px',
      fontWeight: '500',
      flexShrink: 0,
      '&:hover': { backgroundColor: palette.primary.dark },
      textTransform: 'none',
    },
  };
};
